import { ChangeEvent, ReactNode } from 'react';
import { SwitchIndicator, withStyles } from 'vopay';
import styles from './Toggle.module.scss';

const cn = withStyles(styles);

type ToggleProps = {
  label?: ReactNode;
  name: string;
  checked: boolean;
  className?: string;
  readOnly?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
};

export default function Toggle({
  label,
  name,
  checked,
  className,
  readOnly = false,
  onChange = () => {},
}: ToggleProps) {
  return (
    <div className={cn('toggleContainer', className)}>
      <label htmlFor={`checkbox-${name}`} className={cn(readOnly && 'readOnly')}>
        {label}
        <SwitchIndicator checked={checked} className={cn('switch')} />
        <input id={`checkbox-${name}`} type="checkbox" name={name} checked={checked} onChange={onChange} />
      </label>
    </div>
  );
}
